import { combineReducers } from "redux";
import validationReducer from './validationReducer';
// import authService from "../services/authService";
import DefinicoesSistema from "./definicoesSistemaReducer";
import accountReducer from "./accountReducer";
import DadosEmpresaReducer from "./dadosEmpresaReducer";
import DadosdirectorTecnicoReducer from "./dadosdirectorTecnicoReducer";
import DadosPessoalReducer from "./DadosPessoalReducer";
import RequerimentotReducer from "./RequerimentoReducer";
import DadosProfissionalReducer from "./DadosProfissionalReducer";
import FicheirostReducer from "./ficheirosReducer";
import CadastroEstabelecimentoReducer from "./cadastroEstabelecimentoReducer";
import DadosRepresentanteReducer from "./dadosRepresentanteReducer";
import EstabelecimentoLicenciadosReducer from "./estabelecimentoLicenciadosReducer";
import PedidosLicenciamentosReducer from "./pedidosLicenciamentosReducer";
import EmpresasReducer from "./empresasReducer";
import RepresentantesReducer from "./representantesReducer";
import DirectoresTecnicosReducer from "./directoresTecnicosReducer";
import analiseLaboratorialReducer from "./analiseLaboratorialReducer";
import alert from "./alertReducer";
import agenda from "./agendaReducer";
import inspeccao from "./inspecaoReducer";
import {
  dadosUnidadeSaude,
  dadosNotificador,
  dadosEfeitosIndesejados,
  dadosEvolucaoTratamento,
  informacoesMedicamento,
  dadosPaciente,
} from './farmacovigilanciaReducers';
import title from "./titleReducer";


const rootReducer = combineReducers({
  definicoesSistema: DefinicoesSistema,
  account: accountReducer,
  dadospessoal: DadosPessoalReducer,
  dadosEmpresa: DadosEmpresaReducer,
  dadosdirectorTecnico: DadosdirectorTecnicoReducer,
  dadosprofissional: DadosProfissionalReducer,
  requerimento: RequerimentotReducer,
  ficheiros: FicheirostReducer,
  dadosCadastroEstabelecimento: CadastroEstabelecimentoReducer,
  dadosRepresentante: DadosRepresentanteReducer,
  validation: validationReducer,
  estabelecimentoLicenciados: EstabelecimentoLicenciadosReducer,
  PedidosLicenciamentosReducer: PedidosLicenciamentosReducer,
  empresas: EmpresasReducer,
  representantes: RepresentantesReducer,
  directoresTecnicos: DirectoresTecnicosReducer,
  analiseLaboratorial: analiseLaboratorialReducer,
  alert: alert,
  agenda: agenda,
  inspeccao: inspeccao,
  title: title,
  // Slices farmacovigilância
  dadosUnidadeSaude,
  dadosNotificador,
  dadosEfeitosIndesejados,
  dadosEvolucaoTratamento,
  informacoesMedicamento,
  dadosPaciente,
})

export default rootReducer
